import React from 'react';

export default function SubVisual(props){

  return(
    <>
      <div className="subpage-visual ">
        <div className="container">
          <h2 className="section-title font-transform ">{props.title}</h2>
        </div>
      </div>
  </>
)
}

